import angular from 'angular';
import template from './template.html';
import './style.scss';

export class SortColumns {
    teModeColumns = [{
        titleKey: 'NAME',
        className: 'box-border-right',
        name: 'employerDetails.name',
    }, {
        titleKey: 'TALENYA_OFFICE_COLUMN',
        name: 'employerDetails.office',
    }, {
        titleKey: 'CLAIMED',
        name: 'positionClaimed',
    }, {
        titleKey: 'ENGAGED',
        name: 'positionEngaged',
    }, {
        titleKey: 'READY',
        name: 'positionReady',
    }, {
        titleKey: 'SENT',
        name: 'positionSent',
    }, {
        titleKey: 'HIRED',
        name: 'positionHired',
    }, {
        titleKey: 'REJECTED',
        name: 'positionRejected',
    }, {
        titleKey: 'POSTED',
        className: 'box-border-right',
        name: 'positionDetails.created',
        sortable: true,
    }, {
        titleKey: 'PLCMT_FEE',
        className: 'box-border-right',
        name: 'positionDetails.placementFee.sum',
    }, {
        titleKey: '',
        name: '',
    }];

    /* @ngInject */
    constructor($localStorage) {
        this.$localStorage = $localStorage;
    }

    get storage() {
        return this.$localStorage;
    }

    $onInit() {
        this.loadSortState();
    }

    onColumnClick(column) {
        if (column.sortable) {
            this.changeSortState(column.name);
        }
    }

    changeSortState(sortColumnName) {
        const sortState = this.sortState;

        if (sortState.columnName === sortColumnName) {
            sortState.asc = !sortState.asc;
        } else {
            sortState.columnName = sortColumnName;
            sortState.asc = false;
        }

        this.saveSortState(sortState);
        this.onSortStateChange({ sortState });
    }

    loadSortState() {
        const tableState = this.storage[this.tableId];

        if (tableState) {
            const { sortState } = this.storage[this.tableId];

            if (sortState) {
                this.onSortStateChange({ sortState });
            }
        }
    }

    saveSortState(sortState) {
        const tableState = this.storage[this.tableId];

        if (tableState) {
            tableState.sortState = sortState;
        } else {
            this.storage[this.tableId] = { sortState };
        }
    }
}

export const SortColumnsConfiguration = {
    template,
    bindings: {
        tableId: '@',
        columns: '<',
        sortState: '<',
        onSortStateChange: '&',
    },
    controller: SortColumns,
    controllerAs: 'sortColumnsCtrl',
};

angular
    .module('TALENYA-FE')
    .component('sortColumns', SortColumnsConfiguration);